import React from 'react';
import { Container, Jumbotron } from 'reactstrap';

export const Accessiblity: React.FC = () => {
  return (
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <div className="px-0 px-md-5">
          <h1>Barrierefreiheitserklärung</h1>
          <h2>Erklärung zur Barrierefreiheit</h2>
          <p>Das Bundesministerium für Landwirtschaft, Regionen und Tourismus ist bemüht, 
            seine Websites im Einklang mit dem 
            <a href="https://www.ris.bka.gv.at/GeltendeFassung.wxe?Abfrage=Bundesnormen&Gesetzesnummer=20010727" target="_blank">Web-Zugänglichkeits-Gesetz (WZG) idgF</a> {' '}
             zur Umsetzung der <a href="https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=CELEX:32016L2102" target="_blank"> Richtlinie (EU) 2016/2102 des Europäischen Parlaments 
            und des Rates vom 26. Oktober 2016 über den barrierefreien Zugang zu den Websites und 
            mobilen Anwendungen öffentlicher Stellen</a> (Amtsblatt L 327 vom 2.12.2016, S. 1) barrierefrei zugänglich zu machen.</p>

          <p>Diese Erklärung zur Barrierefreiheit gilt für die Applikation <a href="https://wasser.umweltbundesamt.at/parametercodierung">https://wasser.umweltbundesamt.at/parametercodierung/</a></p>
          <h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
          <p>Diese Website ist teilweise mit Konformitätsstufe AA der "Richtlinien für barrierefreie Webinhalte Web – WCAG 2.1" 
            beziehungsweise mit dem geltenden Europäischen Standard EN 301 549 V2.1.2 (2018-08) vereinbar.</p>
          
          <p>Teilen Sie uns bitte mit, wenn Sie Schwierigkeiten mit konkreten Dokumenten haben. 
            Wir bereiten den Inhalt auf Anfrage barrierefrei auf und tauschen die Dokumente in Folge aus beziehungsweise ergänzen diese um barrierefreie Alternativen.
            Für neue Dokumente bemühen wir uns, diese vor Veröffentlichung barrierefrei nach WCAG 2.1 und PDF/UA-konform aufzubereiten.</p>
          
          <p>Inhalte von Dritten die nicht im Einflussbereich des Bundesministeriums liegen, sind von der Richtlinie (EU) 2016/2102 ausgenommen. 
            Für diese Inhalte Dritter kann bezüglich Vereinbarkeit mit Barrierefreiheitsbestimmungen keine Aussage getroffen werden.</p>

          
          <h2>Erstellung dieser Erklärung zur Barrierefreiheit</h2>
          <p>Diese Erklärung wurde am 10.02.2021 erstellt.</p>
          <p>Diese Erklärung wurde am 10.02.2021 aktualisiert.</p>

          <h2>Feedback und Kontaktangaben</h2>

          <p>Sollten Ihnen Barrieren auffallen, die Sie an der Benutzung unserer Website behindern, 
            so bitten wir Sie, uns diese per E-Mail mitzuteilen. Wir werden Ihre Anfrage prüfen und Sie ehestmöglich kontaktieren. 
            Sämtliche Mitteilungen und Anregungen senden Sie uns bitte an wasser@umweltbundesamt.at oder an abt-i3@bmlrt.gv.at 
            mit dem Betreff "Meldung einer Barriere in der Webseite <a href="https://wasser.umweltbundesamt.at/parametercodierung">https://wasser.umweltbundesamt.at/parametercodierung/</a>". 
            Bitte beschreiben Sie das Problem und führen Sie uns die URL(s) der betroffenen Webseite an.</p>

          <p>
            Postadressen:<br/>
            Umweltbundesamt<br/>
            Spittelauer Länder 5, A-1090 Wien<br/>
            <a href="mailto:wasser@umweltbundesamt.at?subject=Meldung einer Barriere in der Webseite https://wasser.umweltbundesamt.at/parametercodierung">wasser@umweltbundesamt.at</a><br/>
          </p>

          <p>
          Bundesministerium für Landwirtschaft, Regionen und Tourismus<br/>
          Stubenring 1, A-1012 Wien<br/>
          <a href="mailto:abt-12@bmlrt.gv.at?subject=Meldung einer Barriere in der Webseite https://wasser.umweltbundesamt.at/parametercodierung">abt-12@bmlrt.gv.at</a><br/>
          </p>

          <h2>Durchsetzungsverfahren</h2>
          <p>Bei nicht zufriedenstellenden Antworten aus oben genannter Kontaktmöglichkeit können Sie sich mittels Beschwerde an die Österreichische Forschungsförderungsgesellschaft mbH (FFG) wenden. 
            Die FFG nimmt über das Kontaktformular Beschwerden auf elektronischem Weg entgegen.</p>
            <p>
            Postadresse:<br />
            Österreichische Forschungsförderungsgesellschaft mbH<br />
            1090 Wien, Sensengasse 1<br />
            </p>
          
            <p><a href="https://www.ffg.at/form/kontaktformular-beschwerdestelle" target="_blank">Kontaktformular der Beschwerdestelle</a></p>

          <p>Diese Beschwerden werden von der FFG dahingehend geprüft, ob sie sich auf Verstöße gegen die Vorgaben des Web-Zugänglichkeits-Gesetzes,
            insbesondere Mängel bei der Einhaltung der Barrierefreiheitsanforderungen, 
            durch den Bund oder einer ihn zuordenbaren Einrichtung beziehen.</p>
          <p>Sofern die Beschwerde berechtigt ist, hat die FFG dem Bund oder den betroffenen Rechtsträgern Handlungsempfehlungen auszusprechen und Maßnahmen vorzuschlagen,
            die der Beseitigung der vorliegenden Mängel dienen.</p>
          <p><a href="https://www.ffg.at/barrierefreiheit/beschwerdestelle" target="_blank">Weitere Informationen zum Beschwerdeverfahren</a></p>
        </div>
      </Container>
    </Jumbotron>
  );
};
